(() => {
  'use strict';
  const init = () => {
    const root = document.querySelector('[data-universal-quote]');
    if (!root || root.dataset.uqReady === '1') return;
    root.dataset.uqReady = '1';

    const quick = root.querySelector('#UniversalQuickLeadForm');
    const details = root.querySelector('#UniversalAdditionalDetailsForm');
    const success = root.querySelector('[data-uq-first-success]');
    const followUp = root.querySelector('[data-uq-details-stage]');
    const finished = root.querySelector('[data-uq-finished]');
    const params = new URLSearchParams(location.search);
    const storageKey = 'umprotech-universal-quick-quote-v1:' + location.pathname;
    const trackingKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid','fbclid'];
    const origin = (params.get('origin') || 'website').slice(0,80);

    let state = {};
    try { state = JSON.parse(sessionStorage.getItem(storageKey) || '{}') || {}; } catch (_) {}
    if (!state.savedAt || Date.now() - state.savedAt > 60 * 60 * 1000) state = {};

    const save = () => {
      state.savedAt = Date.now();
      try { sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) {}
    };
    const fillMetadata = form => {
      if (!form) return;
      const values = {
        '[data-uq-id]': state.id || '',
        '[data-uq-origin]': state.origin || origin,
        '[data-uq-url]': state.landingUrl || location.href,
        '[data-uq-referrer]': state.referrer || document.referrer
      };
      Object.entries(values).forEach(([selector,value]) => {
        const input = form.querySelector(selector);
        if (input) input.value = value;
      });
      form.querySelectorAll('[data-uq-tracking]').forEach(input => {
        const key = input.dataset.uqTracking;
        input.value = (state.tracking && state.tracking[key]) || params.get(key) || '';
      });
    };
    const fireAnalytics = eventName => {
      if (!state.id) return;
      state.events = state.events || {};
      if (state.events[eventName]) return;
      // Do not use the ad-specific conversion event for organic / homepage leads.
      try {
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        const allowed = privacy && typeof privacy.analyticsProcessingAllowed === 'function'
          && privacy.analyticsProcessingAllowed() === true;
        if (allowed) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: eventName, lead_id: state.id, transaction_id: state.id,
            lead_type: 'universal_equipment_quote', form_stage: eventName.endsWith('details_added') ? 'details' : 'quick',
            origin: state.origin || origin
          });
        }
      } catch (_) {}
      state.events[eventName] = true;
      save();
    };

    if (quick) {
      fillMetadata(quick);
      const telephone = quick.elements.namedItem('contact[phone]');
      if (telephone) telephone.addEventListener('input', () => telephone.setCustomValidity(''));
      quick.addEventListener('submit', event => {
        const name = quick.elements.namedItem('contact[name]')?.value.trim() || '';
        const phone = telephone?.value.trim() || '';
        const email = quick.elements.namedItem('contact[email]')?.value.trim() || '';
        const digits = phone.replace(/\D/g,'');
        if (telephone) telephone.setCustomValidity(digits.length >= 7 && digits.length <= 15 ? '' : 'Enter a valid phone number.');
        if (!quick.checkValidity()) {
          event.preventDefault();
          quick.reportValidity();
          return;
        }
        state = {
          id: 'UQ-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2,8).toUpperCase(),
          name,phone,email,origin,landingUrl:location.href,referrer:document.referrer,
          pending:'quick',events:{},tracking:{}
        };
        trackingKeys.forEach(key => { state.tracking[key] = params.get(key) || ''; });
        fillMetadata(quick);
        const subject = quick.querySelector('[data-uq-subject]');
        const body = quick.querySelector('[data-uq-first-body]');
        if (subject) subject.value = 'NEW WEBSITE LEAD | Quick Equipment Quote | ' + state.id;
        if (body) body.value = [
          'Lead ID: ' + state.id, 'Stage: Quick contact', 'Name: ' + name, 'Phone: ' + phone,
          'Email: ' + email, 'Origin: ' + origin, 'Landing URL: ' + location.href
        ].join('\n');
        save();
      }, true);
    }

    if (details) {
      fillMetadata(details);
      const email = details.querySelector('[data-uq-details-email]');
      const nameField = details.querySelector('[data-uq-details-name]');
      const phoneField = details.querySelector('[data-uq-details-phone]');
      const emailConfirm = root.querySelector('[data-uq-email-confirm]');
      const refreshContact = () => {
        if (nameField) nameField.value = state.name || '';
        if (phoneField) phoneField.value = state.phone || '';
        if (email && state.email) email.value = state.email;
        if (!state.email && email) {
          email.classList.add('uq-email-visible');
          if (emailConfirm) emailConfirm.hidden = false;
        }
      };
      refreshContact();
      if (state.detailsDraft) {
        details.querySelectorAll('.ufl-grid input,.ufl-grid select,.ufl-options input').forEach(field => {
          if (!(field.name in state.detailsDraft)) return;
          if (field.type === 'checkbox') field.checked = state.detailsDraft[field.name] === true;
          else field.value = state.detailsDraft[field.name];
        });
      }
      details.addEventListener('submit', event => {
        refreshContact();
        if (!details.checkValidity()) {
          event.preventDefault();
          details.reportValidity();
          return;
        }
        if (!state.id || !['quick_confirmed','details'].includes(state.pending)) {
          event.preventDefault();
          return;
        }
        const confirmedEmail = email?.value.trim() || '';
        if (!confirmedEmail) {event.preventDefault();return;}
        state.email = confirmedEmail;
        state.pending = 'details';
        state.detailsDraft = {};
        details.querySelectorAll('.ufl-grid input,.ufl-grid select,.ufl-options input').forEach(field => {
          state.detailsDraft[field.name] = field.type === 'checkbox' ? field.checked : field.value;
        });
        fillMetadata(details);
        const subj = details.querySelector('[data-uq-details-subject]');
        if (subj) subj.value = 'LEAD UPDATED | Quick Equipment Quote | ' + state.id;
        const parts = [
          'Lead ID: ' + state.id, 'Stage: Additional details',
          'Name: ' + (state.name || ''),'Phone: ' + (state.phone || ''),
          'Email: ' + confirmedEmail, 'Origin: ' + (state.origin || origin)
        ];
        details.querySelectorAll('.ufl-grid input,.ufl-grid select,.ufl-options input').forEach(field => {
          if (!field.name || (field.type === 'checkbox' && !field.checked) || !field.value.trim()) return;
          const label = field.closest('.sq-field')?.querySelector('label')?.textContent.trim() ||
            field.closest('label')?.textContent.trim() || field.name;
          const value = field.tagName === 'SELECT' ? field.selectedOptions[0]?.textContent.trim() : field.value.trim();
          parts.push(label + ': ' + value);
        });
        const body = details.querySelector('[data-uq-details-body]');
        if (body) body.value = parts.join('\n');
        save();
      }, true);
    }

    const firstSent = Boolean(success);
    const detailsSent = Boolean(details && details.querySelector('[data-uq-details-success]'));
    const detailsErrors = Boolean(details && details.querySelector('[data-uq-details-errors]'));
    if (firstSent && state.pending === 'quick') {
      fireAnalytics('umprotech_website_lead_submitted');
      state.pending = 'quick_confirmed';
      save();
    }
    if ((firstSent || detailsSent) && state.pending === 'details' && !detailsErrors) {
      fireAnalytics('umprotech_website_lead_details_added');
      if (quick) quick.hidden = true;
      if (followUp) followUp.hidden = true;
      if (finished) finished.hidden = false;
      state.pending = 'complete';
      state.name = state.phone = state.email = '';
      delete state.detailsDraft;
      save();
    } else if (state.pending === 'quick_confirmed' && firstSent) {
      if (followUp) followUp.hidden = false;
    } else if (state.pending === 'details' && detailsErrors) {
      if (quick) quick.hidden = true;
      if (followUp) followUp.hidden = false;
    }
    const skip = root.querySelector('[data-uq-skip]');
    if (skip) skip.addEventListener('click', () => {
      if (followUp) followUp.hidden = true;
      if (quick) quick.hidden = true;
      if (finished) finished.hidden = false;
      state.name = state.phone = state.email = '';
      state.pending = 'skipped';
      delete state.detailsDraft;
      save();
      finished?.focus({preventScroll:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();